import { isChatDebugEnabled } from '@/modules/chat-matrix-fast/utils/chatDebugLog'

const PREFIX = '[chat-open-jump]'

let seq = 0

function shortId(value: unknown): string {
  if (value == null) {
    return '∅'
  }
  const text = String(value)
  if (text.length <= 24) {
    return text
  }
  return `${text.slice(0, 10)}…${text.slice(-8)}`
}

export function chatOpenJumpLog(
  stage: string,
  extra?: Record<string, unknown>,
): void {
  if (typeof console === 'undefined' || !isChatDebugEnabled()) {
    return
  }

  seq += 1
  console.log(PREFIX, `#${seq}`, stage, {
    t: Math.round(performance.now()),
    ...extra,
  })
}

export function summarizeJumpMessage(
  message: { matrix_event_id?: string; matrix_txn_id?: string; id?: string | number; content?: string; message?: string; created_at?: string } | null | undefined,
): Record<string, unknown> | null {
  if (!message) {
    return null
  }
  const body = String(message.content || message.message || '').replace(/\s+/g, ' ').trim()
  return {
    id: shortId(message.matrix_event_id || message.matrix_txn_id || message.id),
    at: message.created_at ?? null,
    body: body ? body.slice(0, 40) : '',
  }
}

export function summarizeJumpScroll(el: HTMLElement | null | undefined): Record<string, unknown> | null {
  if (!el) {
    return null
  }
  return {
    top: Math.round(el.scrollTop),
    height: el.scrollHeight,
    client: el.clientHeight,
    fromBottom: Math.round(el.scrollHeight - el.scrollTop - el.clientHeight),
  }
}
